import { EpicAuthClient } from '@/features/auth/services/EpicAuthClient'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * SMART on FHIR launch landing page that handles authentication
 * @returns {JSX.Element} The launch component
 */
const CernerLaunch: React.FC = () => {
  const searchParams = useSearchParams().at(0) as URLSearchParams
  const iss = searchParams.get('iss') || ''
  const launch = searchParams.get('launch') || ''

  // Automatically trigger the launch when component mounts
  useEffect(() => {
    const SmartOnFHIRLaunch = async () => {
      try {
        const client = EpicAuthClient.getInstance()
        const redirectUrl = await client.retrieveSmartOnFHIRRedirectUrl(iss, launch)
        window.location.href = redirectUrl
      } catch (error) {
        console.error('Login error:', error)
      }
    }

    if (iss && launch) {
      const timer = setTimeout(() => {
        SmartOnFHIRLaunch()
      }, 1000)

      return () => clearTimeout(timer)
    } else {
      // For development/testing: show error message when parameters are missing
      console.warn('Missing required parameters: iss and launch are required for SMART on FHIR launch')
    }
  }, [iss, launch])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md p-8">
        <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-lg">
          <div className="mt-8">
            <div className="text-center">
              {iss && launch ? (
                <>
                  <div
                    className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status"
                  >
                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                      Loading...
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-gray-600">Initiating SMART on FHIR authorization...</p>
                </>
              ) : (
                <>
                  <div className="mb-4 text-red-600">
                    <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                  </div>
                  <h3 className="mb-2 text-lg font-medium text-gray-900">Missing Launch Parameters</h3>
                  <p className="mb-4 text-sm text-gray-600">
                    This page requires SMART on FHIR launch parameters to function properly.
                  </p>
                  <p className="text-xs text-gray-500">
                    Expected URL format: <code className="rounded bg-gray-100 px-1">/launch?iss=URL&launch=TOKEN</code>
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CernerLaunch
